import { Record } from "immutable";

export type AssigneeSectionStatType = {
  bestScore?: number;
  worstScore?: number;
  averageScore?: number;
  firstScore?: number;
  lastScore?: number;
  sessionsCompleted?: number;
  totalStudyTime?: number;
};

export const defaultAssigneeSectionStat: AssigneeSectionStatType = {
  bestScore: undefined,
  worstScore: undefined,
  averageScore: undefined,
  firstScore: undefined,
  lastScore: undefined,
  sessionsCompleted: undefined,
  totalStudyTime: undefined
};

export default class AssigneeSectionStat extends Record(
  defaultAssigneeSectionStat
) {}
